import React from 'react'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { useNavigate } from 'react-router-dom'

const NotFound = () => {
  const navigate = useNavigate()

  const handleGoBack = () => {
    navigate(-1)
  }

  return (
    <Container
      maxWidth='xl'
      sx={{ 
        mt: 2,
        display: 'flex'
      }}
    >
      <Typography
        variant='h5'
        sx={{
          mr: 4
        }}
      >
        <span style={{ color: '#ff5a60' }}>Oops!</span> This is awkward... You are looking for something that doesn&apos;t actually exist.
      </Typography>
      <Button
        variant='contained'
        onClick={handleGoBack}
        size='small'
        sx={{
          backgroundColor: '#3A6DAA'
        }}
      >
        Go Back
      </Button>
    </Container>
  )
}

export default NotFound